import {DateTime, Duration} from "luxon";

export const addDateFilters = (Vue) => {
    Vue.filter('fromNow', date => DateTime.fromISO(date).toRelative());
    Vue.filter('fullDate', date => DateTime.fromISO(date).toFormat('ff'));
    Vue.filter('minutesToTime', function (minutes) {
        var duration = Duration.fromObject({ minutes: minutes });
        return duration.toFormat('h\'h\'mm\'min\'');
    });
    /*Vue.filter('fullDate', date => moment(date).format('lll'));
    Vue.filter('dateOnly', date => moment(date).format('ll'));
    Vue.filter('calendar', date => moment(date).calendar());*/
}
